
import Vue, { PropType } from 'vue';
import { CustomComponentType } from '@sageworks/dynamic-forms';
import { TuxInputText } from '@tuxedo/components/src/components';
import { Customer } from '@sageworks/jpi/';
import { AutoFactory, OnlinePortalLoanApplicationsApi } from '@sageworks/jpi';

export default Vue.extend({
	name: 'AddNewPrimaryRoleAccessPopup',
	components: {
		TuxInputText
	},
	props: {
		entityType: {
			type: Customer.TypeEnum
		},
		componentType: {
			type: String as PropType<CustomComponentType>
		},
		componentLabel: {
			type: String,
			default: () => ''
		},
		loanApplicationId: {
			type: Number
		}
	},
	data() {
		return {
			canFillOutInformation: true,
			options: [
				{ text: 'Yes, I am able to fill out their information', value: true },
				{ text: 'No, I need them to fill out their information', value: false }
			],
			firstName: '',
			lastName: '',
			email: '',
			attemptedToSaveAndContinueWithInvalidData: false,
			confirmingDetails: false
		};
	},
	computed: {
		continueButtonText(): string {
			return !this.confirmingDetails ? 'Save and Continue' : `Invite ${this.componentLabel} to Application`;
		},
		validData(): boolean {
			return this.firstName.length !== 0! && this.lastName.length !== 0 && this.email.length !== 0;
		}
	},
	methods: {
		closeModal() {
			this.$bvModal.hide(`can-fill-out-information-modal-${this.componentType}-${this.entityType}`);
		},
		back() {
			this.confirmingDetails = false;
		},
		saveAndContinue() {
			if (this.canFillOutInformation) {
				this.$emit('add-entity');
				this.closeModal();
			}
			if (!this.confirmingDetails && !this.validData) {
				this.attemptedToSaveAndContinueWithInvalidData = true;
				return;
			}
			if (!this.confirmingDetails && this.validData) {
				this.confirmingDetails = true;
				return;
			}
			if (this.confirmingDetails) {
				this.inviteToLoanApplication();
			}
		},
		async inviteToLoanApplication() {
			let invitedCustomer = await AutoFactory.get(OnlinePortalLoanApplicationsApi).inviteToApplication({
				loanApplicationId: this.loanApplicationId,
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email
			});
			this.$emit('entity-invited', { id: invitedCustomer.id, type: this.entityType.toLowerCase() });
		},
		clearData() {
			this.canFillOutInformation = true;
			this.firstName = '';
			this.lastName = '';
			this.email = '';
			this.attemptedToSaveAndContinueWithInvalidData = false;
			this.confirmingDetails = false;
		}
	}
});
